import { render } from "./intGrantCard.vue?vue&type=template&id=7c76a9eb&scoped=true"
import script from "./intGrantCard.vue?vue&type=script&lang=js"
export * from "./intGrantCard.vue?vue&type=script&lang=js"

import "./intGrantCard.vue?vue&type=style&index=0&id=7c76a9eb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c76a9eb"]])

export default __exports__